import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesPreview from "./components/ServicesPreview";
import StatsSection from "./components/StatsSection";
import VehiclesPreview from "./components/VehiclesPreview";
import TestimonialsSection from "./components/TestimonialsSection";
import CtaBanner from "./components/CtaBanner";

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <ServicesPreview />
        <VehiclesPreview />
        <TestimonialsSection />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}
